import React, { MouseEvent, useState, useEffect, useRef } from 'react';
import { formatMoneda } from '../../util/varios';
import moment from 'moment';
import { Mensaje } from '../mensajes';
import axios from "axios";
import { TableBody, TableRow, TableCell } from '@material-ui/core';
import { Dimmer, Loader } from 'semantic-ui-react';
import useTable from '../useTable';
import ActualizarMoviles from './gestionarMoviles';
import VisualizarMoviles from './actualizarMoviles';
/* import RegistrarPagoNotadeEntregaV from './registrarPagoNotaEntrega';
import ActualizarVacios from './actualizarVacios';
import GestionarVacios from './gestionarVacios'; */


function GestionMoviles(props) {
    const headCells = [
        { id: '8', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'CEDULA/RIF', textAlign: 'center' },
        { id: '1', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'NOMBRE', textAlign: 'center' },
        { id: '2', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'DIRECCION', textAlign: 'center' },
        { id: '9', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'ACCION', textAlign: 'center' },
    ]

    const txtBuscar = useRef();
    const [mensaje, setMensaje] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
    const [valor, setValor] = useState([]);
    const [clientemoviles, setClientemoviles] = useState([]);
    const [total, setTotal] = useState(0.00);
    const [mostrar, setMostrar] = useState(false);
    const [mostrar1, setMostrar1] = useState(false);
    const [mostrar2, setMostrar2] = useState(false);
    const [opera, setOpera] = useState(0);
    const [idnot, setIdnot] = useState(0)
    const [detavacios, setDetavacios] = useState([]);
    const [abono, setAbono] = useState(0.0);
    const [colorF, setColorF] = useState([])
    const color = [];
    const [datos, setDatos] = useState([{
        color: '#0d6efd',
        nombre: 'Total Cobrado',
        valor: '545.555,23'
    }, {
        color: '#dc3545',
        nombre: 'Total x Cobrar',
        valor: '54.445,42'
    }
    ]);
    const [records, setRecords] = useState([]);
    const [municipiosData, setMunicipiosData] = useState([]);
    const [colorG, setColorG] = useState([
        '#0d6efd',
        '#dc3545'


    ]);
    const [rm, setRM] = useState({
        enero: 0.00,
        febrero: 0.00,
        marzo: 0.00,
        abril: 0.00,
        mayo: 0.00,
        junio: 0.00,
        julio: 0.00,
        agosto: 0.00,
        septiembre: 0.00,
        octubre: 0.00,
        noviembre: 0.00,
        diciembre: 0.00
    });
    const [activate, setActivate] = useState(false);
    const [fechaSistema, setFechaSistema] = useState(JSON.parse(sessionStorage.getItem('fechasistema')));
    const [anioActu, setAnioActu] = useState(sessionStorage.getItem('anioactu'));
    const [label, setLabel] = useState([]);
    const [labelu, setLabelu] = useState([]);

    const [data, setData] = useState();

    const [options, setOptions] = useState();



    let token = sessionStorage.getItem('jwtToken');
    let op = require('../../../public/modulos/datos');
    const ncaja = JSON.parse(sessionStorage.getItem("numcaja"));
    const accmoviles = JSON.parse(
        sessionStorage.getItem("accmovilesc")
    );
    const txtMesPetro = useRef();
    const txtMesUTE = useRef();

    const [filterFn, setFilterFn] = useState({
        fn: (items) => {
            return items;
        },
    });

    const { TblContainer, TblHead, TblPagination, recordsAfterPagingAndSorting } =
        useTable(records, headCells, filterFn);

    const handleSearch = (e) => {
        let target = e.target;

        setFilterFn({
            fn: (items) => {
                if (target.value === "") {
                    return items;
                } else {
                    return items.filter((x) => {
                        if (
                            x.rif.toLowerCase().includes(target.value.toLowerCase()) ||
                            x.cliente.toLowerCase().includes(target.value.toLowerCase()) ||
                            x.direccion.toLowerCase().includes(target.value.toLowerCase())
                        ) {
                            return x;
                        }
                    });
                }
            },
        });
    };


    const seleccionarRegistros = () => {

        let endpoint = `${op.conexion}/api/servicios/consultaregistromoviles`;

        setActivate(true);

        axios
            .get(endpoint, {
                headers: {
                    "x-access-token": `${token}`,
                },
            })
            .then(function (response) {
                if (response.status === 200) {
                    if (response.data.length > 0) {
                        setRecords(response.data);
                        txtBuscar.current.focus();
                    }
                }
            })
            .catch(function (error) {
                setMensaje({
                    mostrar: true,
                    titulo: "Error",
                    texto: error.response.data.message,
                    icono: "error",
                });
                setActivate(false);
            })
            .finally(() => {
                setActivate(false);
            });
    };


    const blanquear = () => {
        setIdnot(0);
    }

    useEffect(() => {
        seleccionarRegistros();
    }, []);

    const seleccionarMoviles = (id, ope) => {
        let campos = "idmovil, idpropietario, trim(placa) as placa, trim(marca) as marca, trim(modelo) as modelo, trim(uso) as uso, trim(nombrerespo) as nombrerespo, trim(cedularespo) as cedularespo";
        let nomtab = "moviles";
        let nomid = "idpropietario";
        let orden = "idmovil desc";
        let endpoint = `${op.conexion}/api/consulta/modeliorder?campos=${campos}&id=${id}&nomtab=${nomtab}&nomid=${nomid}&orden=${orden}`;

        setActivate(true);

        axios
            .get(endpoint, {
                headers: {
                    "x-access-token": `${token}`,
                },
            })
            .then(function (response) {
                if (response.status === 200) {
                    if (response.data.length > 0) {
                        if (ope === 5) {
                            setClientemoviles(response.data);
                            setMostrar1(true);
                        } else {
                            setClientemoviles(response.data);
                            setMostrar2(true);
                        }      
                    } else {
                        setClientemoviles([]);
                        setMostrar2(false);
                    }
                }
            })
            .catch(function (error) {
                setMensaje({
                    mostrar: true,
                    titulo: "Error",
                    texto: error.response.data.message,
                    icono: "error",
                });
                setActivate(false);
            })
            .finally(() => {
                setActivate(false);
            });
    };

    const onGestionar = (item, ope) => (e) => {


        if (ope === 1 || ope === 5) {
            if (accmoviles && accmoviles.toString().substring(0, 1) === "1") {
                if (ope === 5) {
                    seleccionarMoviles(item.idagente, ope);
                    setOpera(ope);
                } else {
                    setMostrar1(true);
                    setOpera(ope);
                }
            } else {
                setMensaje({
                    mostrar: true,
                    titulo: "Notificación.",
                    texto: "¡No Posee Permiso para Realizar esta Acción!",
                    icono: "error",
                });
            }

        } else if (ope === 2) {
            if (accmoviles && accmoviles.toString().substring(1, 2) === "1") {
                seleccionarMoviles(item.idagente, ope);
                setOpera(ope);
            } else {
                setMensaje({
                    mostrar: true,
                    titulo: "Notificación.",
                    texto: "¡No Posee Permiso para Realizar esta Acción!",
                    icono: "error",
                });
            }
        } else if (ope === 3) {
            if (accmoviles && accmoviles.toString().substring(2, 3) === "1") {
                seleccionarMoviles(item.idagente, ope);
                setOpera(ope);
            } else {
                setMensaje({
                    mostrar: true,
                    titulo: "Notificación.",
                    texto: "¡No Posee Permiso para Realizar esta Acción!",
                    icono: "error",
                });
            }

        } else {
            if (accmoviles && accmoviles.toString().substring(3, 4) === "1") {
                seleccionarMoviles(item.idagente, ope);
                setOpera(ope);
            } else {
                setMensaje({
                    mostrar: true,
                    titulo: "Notificación.",
                    texto: "¡No Posee Permiso para Realizar esta Acción!",
                    icono: "error",
                });
            }
        }

    };

    return (
        <div className='col-md-12 mx-auto'>
            <div className='col-md-12 mt-2'>
                <div>
                    <Mensaje mensaje={mensaje}
                        onHide={() => setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' })} />
                    <div className="container-fluid px-3 py-2">
                        <div className="row col-md-10 card py-3 mx-auto">
                            <div className="row col-md-12 mx-auto">

                                <div className='col-md-12 row h-100'>
                                    <div className='col-md-12 row mx-auto py-3 m-0'>
                                        <div className="row col-md-12 m-0 px-0">
                                            <div className="input-group col-md-6 input-group-sm px-0">
                                                <input
                                                    type="text"
                                                    onChange={handleSearch}
                                                    placeholder="Buscar"
                                                    title="Buscar Clasificador de Vacios"
                                                    className="form-control text-uppercase"
                                                    ref={txtBuscar}
                                                />
                                                <button
                                                    className="btn"
                                                    style={{
                                                        pointerEvents: "none",
                                                        backgroundColor: "rgba(5, 81, 130, 1)",
                                                        color: "#FFFFFF",
                                                    }}
                                                >
                                                    <i className="fa fa-search"></i>
                                                </button>
                                            </div>
                                            <div className='col-pd-60 ml-auto'>
                                                <button
                                                    onClick={onGestionar('', 1)}
                                                    className="btn btn-sm btn-primary rounded-circle mx-1"
                                                >
                                                    <i className="fas fa-plus"></i>{" "}
                                                </button>
                                            </div>
                                        </div>
                                        <div className='col-md-12 mt-2 px-0 mx-0 rounded'>
                                            <TblContainer container={{ height: 220, width: '100%', overflow: 'auto', padding: '2px', fontSizeAdjust: '0.6' }} >
                                                <TblHead />
                                                <TableBody className='overflow-hidden table-bordered' >
                                                    {
                                                        records && recordsAfterPagingAndSorting().map((item, index) => (
                                                            <TableRow key={index} style={{ padding: "0" }}>

                                                                <TableCell className='align-middle bg-light' style={{ textAlign: "center", width: '80px' }} >{item.rif}</TableCell>
                                                                <TableCell className='align-middle' style={{ width: '350px' }} >{item.cliente}</TableCell>
                                                                <TableCell className='align-middle' style={{ width: '500px' }} >{item.direccion}</TableCell>
                                                                <TableCell
                                                                    className="align-middle"
                                                                    style={{
                                                                        textAlign: "center",
                                                                        width: "120px",
                                                                    }}
                                                                >
                                                                    <button
                                                                        className="btn btn-sm btn-primary rounded mx-1"
                                                                        title="Visualizar Moviles por Cliente"
                                                                        onClick={onGestionar(item, 5)}
                                                                    >
                                                                        <i className="fas fa-plus" />
                                                                    </button>
                                                                    <button
                                                                        className="btn btn-sm btn-info rounded mx-1"
                                                                        title="Visualizar Moviles por Cliente"
                                                                        onClick={onGestionar(item, 4)}
                                                                    >
                                                                        <i className="fas fa-eye" />
                                                                    </button>
                                                                    <button
                                                                        className="btn btn-sm btn-warning rounded mx-1"
                                                                        title="Modificar Movil por Cliente"
                                                                        onClick={onGestionar(item, 2)}
                                                                    >
                                                                        <i className="fas fa-pencil-alt" />
                                                                    </button>
                                                                    <button
                                                                        className="btn btn-sm btn-danger rounded"
                                                                        title="Eliminar Movil por Cliente"
                                                                        onClick={onGestionar(item, 3)}
                                                                    >
                                                                        <i className="fa fa-trash" />
                                                                    </button>
                                                                </TableCell>
                                                            </TableRow>
                                                        ))
                                                    }
                                                </TableBody>
                                            </TblContainer>
                                            <TblPagination />
                                        </div>


                                    </div>

                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <ActualizarMoviles
                show={mostrar1}
                ope={opera}
                data={clientemoviles}
                onRenderizar={seleccionarRegistros}
                onHideCancelar={() => {
                    setMostrar1(false);
                }}
            />
            <VisualizarMoviles
                show={mostrar2}
                ope={opera}
                data={clientemoviles}
                onRenderizar={seleccionarRegistros}
                onHideCancelar={() => {
                    setMostrar2(false);
                }}
            />
            <Dimmer active={activate} inverted>
                <Loader inverted>cargando...</Loader>
            </Dimmer>
        </div>
    );

}

export default GestionMoviles;


// WEBPACK FOOTER //
// ./src/components/servicios/tablaGestionMoviles.js